module.exports = __webpack_public_path__ + "img/SKMJ_saferoad4.fca6bf53.jpg";